import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import classNames from 'classnames';

import { useIsAuthenticated } from '@azure/msal-react';

import { CurvedBackground, LoadingIndicator, ModalComponent, Section } from 'features/order-tracker/shared-components';
import { closeOTPopUp, initSummaryPage } from 'features/order-tracker/store/actions';
import { useHighDemandEngineerVisitsBannerManager } from 'features/order-tracker/store/hooks';
import {
  getAmendAppointmentModalOpened,
  getModalInformation,
  getOrderSummary,
} from 'features/order-tracker/store/selectors';
import { toggleMainWindowScroll } from 'features/order-tracker/utils';

import { AmendAppointmentPage } from '../AmendAppointmentPage';
import { Notification } from '../AmendAppointmentPage/components';
import {
  AppointmentsColumn,
  HelpSection,
  MilestonesColumn,
  OrderSummarySection,
  OrderTrackerPopUpForm,
  SnapshotCardSection,
  UsefulLinksSection,
} from './components';
import { Banner } from './components/Banner/Banner';
import { GeneralErrorComponent } from './components/ErrorComponents';
import { ERROR_TYPE } from './components/ErrorComponents/components/GeneralError/constants';

// import { MEDALLIA_ORDER_FORM_ID } from './contants';
import styles from './styles.module.scss';

declare global {
  interface Window {
    KAMPYLE_ONSITE_SDK: any;
  }
}

export const OrderSummaryPage: React.FC = () => {
  const { isFetching, isGeneralAPIFailed } = useSelector(getOrderSummary);
  const { isVisibleOTPopUp } = useSelector(getModalInformation);
  const hasAmendAppointmentModalOpened = useSelector(getAmendAppointmentModalOpened);
  const dispatch = useDispatch();

  const isAuthenticated = useIsAuthenticated();
  useHighDemandEngineerVisitsBannerManager();

  const [isShowBanner, setIsShowBanner] = useState(!isAuthenticated);
  const handleHideBanner = (): void => {
    setIsShowBanner(false);
  };

  const initOrderSummaryPageFlow = (): void => {
    dispatch(initSummaryPage());
  };

  useEffect(() => {
    setIsShowBanner(!isAuthenticated);
  }, [isAuthenticated]);

  useEffect(() => {
    if (isFetching && isVisibleOTPopUp) {
      dispatch(closeOTPopUp());

      toggleMainWindowScroll();
    }
  }, [isFetching]);

  useEffect(() => {
    initOrderSummaryPageFlow();
    sessionStorage.removeItem('medallia');
  }, []);

  // const onExitsummaryPage = () => {
  //   const val = sessionStorage.getItem('medallia') ?? 'false';
  //   // load the form and store status (true/false) in neb_status
  //   const nebStatus = window.KAMPYLE_ONSITE_SDK.loadForm(MEDALLIA_ORDER_FORM_ID);
  //   if (hasAmendAppointmentModalOpened === false && nebStatus === true) {
  //     if (!JSON.parse(val)) {
  //       window.KAMPYLE_ONSITE_SDK.showForm(MEDALLIA_ORDER_FORM_ID);
  //       sessionStorage.setItem('medallia', 'true');
  //     }
  //     if (JSON.parse(val)) {
  //       document.removeEventListener('visibilitychange', onExitsummaryPage);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   if (hasAmendAppointmentModalOpened === false) {
  //     document.addEventListener('visibilitychange', () => {
  //       if (document.visibilityState !== 'visible') {
  //         onExitsummaryPage();
  //       }
  //     });
  //   } else {
  //     document.removeEventListener('visibilitychange', onExitsummaryPage);
  //   }
  //   return () => {
  //     document.removeEventListener('visibilitychange', onExitsummaryPage);
  //   };
  // }, [hasAmendAppointmentModalOpened]);

  const orderSummaryContent = (
    <>
      <Notification />
      <ModalComponent />
      <CurvedBackground>
        <SnapshotCardSection />
        <Banner isShowBanner={isShowBanner} handleHideBanner={handleHideBanner} />
      </CurvedBackground>
      <Section bgColor="gray" className={classNames(styles.mainContainer, { [styles.bannerPadding]: isShowBanner })}>
        <AppointmentsColumn />
        <MilestonesColumn />
      </Section>
      <OrderSummarySection />
      <UsefulLinksSection />
      <HelpSection />
      {hasAmendAppointmentModalOpened && <AmendAppointmentPage />}
    </>
  );

  const errorContent = <GeneralErrorComponent errorType={ERROR_TYPE.orderNotFound} />;

  const orderSummaryView = isGeneralAPIFailed ? errorContent : orderSummaryContent;

  return (
    <div
      className={classNames('component-order-tracker__container', {
        [styles.orderTrackerContainer]: isFetching || isGeneralAPIFailed,
      })}
    >
      {isFetching ? <LoadingIndicator /> : orderSummaryView}
      {isVisibleOTPopUp && <OrderTrackerPopUpForm initOrderSummaryPageFlow={initOrderSummaryPageFlow} />}
    </div>
  );
};
